import { post } from '@/utils/request'

// 会员管理-表格数据
export function getMemberListReq(data) {
    return post({
        data,
        url: 'member/memberManage/memberList'
    })
}

// 会员管理-注销会员（单个）
export function delOneMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/deleteMemberSingle'
    })
}

// 会员管理-启用会员（单个）
export function enableOneMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/activeMemberSingle'
    })
}

// 会员管理-批量删除会员
export function delMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/deleteMember'
    })
}

// 会员管理-唯一id生成器
export function getIdReq(data) {
    return post({
        data,
        url: 'member/memberManage/getGUID'
    })
}
// 会员管理-生成邀请码
export function getInvitationCode(data) {
    return post({
        data,
        url: 'member/memberManage/getInvitationCode'
    })
}

// 会员管理-添加会员
export function addMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/addMember'
    })
}

// 会员管理-编辑会员
export function editMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/editMember'
    })
}

// 会员管理-会员校验 校验是否有相同的用户存在 
export function checkMemberReq(data) {
    return post({
        data,
        url: 'member/memberManage/userIsExist'
    })
}

// 会员管理-获取指定会员信息(编辑弹窗回显)
export function getMemberDetailReq(data) {
    return post({
        data,
        url: 'member/memberManage/getMemberDetail'
    })
}

// 会员管理-获取指定会员信息(详情弹窗回显)[实名认证详情页面的接口0]
export function getMemberSeeDetailReq(data) {
    return post({
        data,
        url: 'member/memberManage/getMemberAutonymInfo'
    })
}

// 会员管理-获取弹窗的区域列表数据(初始化)
export function getDefaultAreaTreeDataReq(data) {
    return post({
        data,
        url: 'member/memberManage/getAreaDataInit'
    })
}

// 会员管理-获取弹窗的区域列表数据(展开结构)
export function getAreaTreeDataReq(data) {
    return post({
        data,
        url: 'member/memberManage/getAreaDataDetail'
    })
}

// 会员管理-弹窗的上级会员下拉框(获取所属会员列表)
export function getHigherLevelMemberMap(data) {
    return post({
        data,
        url: 'member/memberManage/getAffiliationMemberList'
    })
}

// 会员管理-获取推荐人列表（未用到该接口）
export function getRecommenderMap(data) {
    return post({
        data,
        url: '!sys/security/~java/MemberManage.getMemberList'
    })
}
